import { render, staticRenderFns } from "./CatalogThumb.vue?vue&type=template&id=83ca7f9c&scoped=true&"
import script from "./CatalogThumb.vue?vue&type=script&lang=js&"
export * from "./CatalogThumb.vue?vue&type=script&lang=js&"
import style0 from "./CatalogThumb.vue?vue&type=style&index=0&id=83ca7f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ca7f9c",
  null
  
)

export default component.exports